// /src/pages/admin/ArtworksListPage.tsx

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getArtworks } from "../../lib/firebase/firestore";
import { Artwork } from "../../types";
import { deleteArtwork } from '../../lib/firebase/firestore';


export const ArtworksListPage = () => {
  const [artworks, setArtworks] = useState<Artwork[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadArtworks = async () => {
      try {
        const data = await getArtworks();
        setArtworks(data);
      } catch (error) {
        console.error("Failed to fetch offering:", error);
      } finally {
        setLoading(false);
      }
    };

    loadArtworks();
  }, []);

  if (loading) return <div>Loading offered software...</div>;

  return (
    <div>
      <h2>Software Offrering</h2>
      <Link
        to="/admin/artworks/new"
        style={{ marginBottom: "1rem", display: "inline-block" }}
      >
        ➕ Add New Offrers
      </Link>
      <ul style={{ listStyle: "none", paddingLeft: 0 }}>
        {artworks.map((artwork) => (
          <li
            key={artwork.id}
            style={{ borderBottom: "1px solid #eee", padding: "0.5rem 0" }}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>{artwork.title}</span>
              <div>
                <Link
                  to={`/admin/artworks/edit/${artwork.id}`}
                  style={{ marginRight: "1rem" }}
                >
                  ✏️ Edit
                </Link>
                <button
                  onClick={async () => {
                    if (
                      window.confirm(
                        "Are you sure you want to delete this offering?"
                      )
                    ) {
                      try {
                        await deleteArtwork(artwork.id);
                        alert("offering deleted successfully!");
                      } catch (error) {
                        console.error("Error deleting offerings:", error);
                        alert("Failed to delete offering");
                      }
                    }
                  }}
                >
                  🗑️ Delete
                </button>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
